import { render, staticRenderFns } from "./ActivateButton.vue?vue&type=template&id=0e0ad872&"
import script from "./ActivateButton.vue?vue&type=script&lang=js&"
export * from "./ActivateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports